let company = {
    companyName: "Company name",
    enterCompanyName: "Please enter company name",
    companyNumber: "Company ID",
    addCompany: "Add company",
    companyDetail: "Company detail",
}

export default company
